import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CartService} from "../../services/cart.service";
import {UserService} from "../../services/user.service";
import {SettingsService} from "../../services/settings.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit, OnChanges {
    // The change detector looks for the first element matching the selector in the view DOM
    @ViewChild('loginModal', {static: false}) loginWindow: NgbModal | undefined;

    // Decides whether the login component should be displayed or not
    // E.g. the token of the user is no longer valid, the user must login again
    @Input() displayLoginCmp: boolean = true;

    @Output() loggedInEvent = new EventEmitter<boolean>();

    modalRef: NgbModalRef | undefined
    showLoader = false;
    credentials: {username: string, password: string} = {username: '', password: ''};
    validLogin: { type: string, message: string } = {type: '', message: ''};
    saveData: boolean = false;

    constructor(
        private cartService: CartService,
        private userService: UserService,
        private modalService: NgbModal,
        private settings: SettingsService
    ) {
    }

    /**
     * Emits an event, whether the logout btn is shown or not
     * @param loggedIn user is logged in or not
     */
    showLogoutBtn(loggedIn: boolean) {
        this.loggedInEvent.emit(loggedIn);
    }

    /**
     * Opens the modal login window.
     * @returns void
     */
    showLoginCmp(): void {
        // backdop:statis means that the modal window does not close on click
        if (this.loginWindow && !this.modalRef) {
            this.modalRef = this.modalService.open(this.loginWindow, {backdrop: 'static', keyboard: false});
        }
    }

    /**
     * Listener is fired if the input property changes
     * @param changes object of changes stored the input type
     * @returns void
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['displayLoginCmp'].currentValue) {
            if (changes['displayLoginCmp'].previousValue) {
                this.validLogin.type = 'danger';
                this.validLogin.message = 'Ihre Session ist abgelaufen. Bitte melden Sie sich erneut an.';
            }
            this.showLoginCmp();
        }
    }

    async ngAfterViewInit() {
        this.credentials = await this.settings.get('credentials') || {username: '', password: ''};
        this.saveData = this.credentials.username !== '' && this.credentials.password !== '';
        this.showLoginCmp();
    }

    /**
     * The user logs in.
     * The token, the expiration date and the user id are stored in a local storage.
     * @returns void
     */
    async login() {
        // Checks if username or password exists.
        this.credentials.username = this.credentials.username.trim();
        this.credentials.password = this.credentials.password.trim();
        if (this.credentials.username !== '' && this.credentials.password !== '') {
            // Show loading bar
            this.showLoader = true;

            // save / delete login data if requested
            if (this.saveData) {
                await this.settings.set('credentials', this.credentials);
            } else {
                await this.settings.delete('credentials');
            }

            // Do http login process
            try {
                await this.userService.login(this.credentials);
                await this.onLoginSuccess();
            } catch (e) {
                this.onLoginError();
            }
        } else {
            this.onLoginError();
        }
    }

    async onLoginSuccess() {
        this.validLogin.type = '';
        this.validLogin.message = '';
        // Get cart items of the user
        try {
            await this.cartService.onUserLogin();
            this.showLoader = false;
            // Dismiss login component
            this.modalRef?.dismiss();
            // Show logout button
            this.showLogoutBtn(true);
        } catch (e) {
            this.showLoader = false;
            this.validLogin.type = 'danger';
            this.validLogin.message = 'Fehler bei der Aktualisierung Ihres Warenkorbes';
        }
    }

    onLoginError() {
        this.showLoader = false;
        this.validLogin.type = 'danger';
        this.validLogin.message = 'Benutzername oder Passwort ungültig';
        // Hide logout button
        this.showLogoutBtn(false);
    }
}
